<template>
    <div @mouseover="loadPopovers" class="wp-step2">
        <new-booking-flayer :from-wp="true"/>
        <new-package-section :from-wp="true"/>
    </div>
</template>

<script>
import NewPackageSection from "../../layouts/NewPackageSection";
import NewBookingFlayer from "../../layouts/NewBookingFlayer";

export default {
    name: 'WpStep2',
    components: {NewBookingFlayer, NewPackageSection},
    methods: {
        loadPopovers(){
            $('[data-toggle="popover"]').popover()
        },
    }
}
</script>
